/* The toolbar and the empty state — the two things Scale's data grid does not
   provide. Everything a table used to need from us (the table element, sort
   headers, row tinting, cell padding, sticky headers) now comes from
   scale-data-grid, so those rules are gone rather than carried over.

   The toolbar is slotted into the grid's title block and runs the width of it,
   which takes one rule inside the shadow root — see the note beside `density` in
   DataGrid.tsx. Here it is an ordinary left-aligned row: search first, then the
   scopes, with the narrowed count pushed to the far end. */

.toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

/* Stands in for the grid's title block on the empty state, where there is no
   grid to slot into and the toolbar would otherwise sit flush against the
   heading above it. The 24px matches the title block's own left padding, so the
   search box does not move when the last row is filtered away. */
.toolbarBlock {
  display: flex;
  align-items: center;
  min-height: 72px;
  padding: 0 16px 0 24px;
}

/* The same growth the slot wrapper is given inside the grid, so the count keeps
   to the far end in both states. */
.toolbarBlock .toolbar {
  flex: 1 1 auto;
  min-width: 0;
}

.searchBox {
  flex: 0 1 260px;
  min-width: 0;
}

/* 32px, the height of the chips beside it. Scale's field is 44 and its own
   `size` prop is deprecated in favour of exactly this: the two custom properties
   the component declares for its height. The rest — the padding, and a
   placeholder Scale keeps transparent until focus — has no custom property to
   set, so it goes through the field's own style injection; see `searchStyles`
   in DataGrid.tsx. */
.searchBox scale-text-field {
  --height: 32px;
  --min-height: 32px;
}

/* The chips draw themselves — scale-chip is already 32px tall with its own
   selected state — so this is only the row they sit in. */
.chips {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.count {
  margin-left: auto;
  font-size: var(--co-size-small);
  color: var(--co-text-additional);
  font-variant-numeric: tabular-nums;
}

/* The data grid's native footer also centers this Scale pagination primitive
   inside a 44px info row. Reproduce only that public composition here; the
   pagination component owns its controls, separators, focus and responsive UI. */
.pager {
  display: flex;
  align-items: center;
  justify-content: center;
  min-block-size: 44px;
  border-top: 1px solid var(--co-border);
}

.pager scale-pagination {
  max-inline-size: 100%;
}

.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 40px;
  text-align: center;
  color: var(--co-text-additional);
}

.empty b {
  color: var(--co-text);
  font-size: var(--co-size-caption);
}

.clear {
  margin-top: 6px;
  font-family: var(--co-font);
  font-size: var(--co-size-small);
  background: none;
  border: none;
  padding: 0;
  color: var(--co-magenta);
  cursor: pointer;
  text-decoration: underline;
}
